import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

/**
 * for this page
 */
import Calender from '../calender';

import { formatDateTime, formatday } from '../../../../utils/timeUnit';

import { getCalenderTableData } from '../../../../../../../services/api';

class DataTable extends React.PureComponent {
    static propTypes = {
        // content: PropTypes.object,
    };

    state = {
        date: '',
        day: '',
        tableData: {},
        columns: {
            OnlineDate: '申购',
            ListDate: '上市',
            IssueResultPublDate: '公布中签率',
            PayDateOnline: '缴款日',
            IssueNumPublDate: '公布中签号',
        },
        loading: true,
    };

    handleChangeMonth = val => {
        console.log(val);
        this.setState(
            {
                date: formatDateTime(`${val} 00:00:00`, 15),
                day: formatday(new Date(val).getDay()),
            },
            () => {
                this.setState(
                    {
                        loading: true,
                    },
                    () => {
                        this.asyncGetCalenderTableData(val);
                    },
                );
            },
        );
    };

    asyncGetCalenderTableData = async date => {
        const res = await getCalenderTableData(date);

        if (res) {
            this.setState({
                tableData: res.body,
                loading: false,
            });
        }
    };

    render() {
        const { date, day, tableData, columns, loading } = this.state;

        const td = e => {
            const doms = e.map((item, index) => {
                return (
                    <div key={index} className={styles.col_td} style={{ marginRight: (index + 1) % 7 === 0 ? -1 : 2 }}>
                        {item[1]}
                    </div>
                );
            });

            return doms;
        };

        const table = () => {
            const row = [];

            if (loading) {
                return <div className={styles.loading}>加载中...</div>;
            }

            if (tableData && Object.keys(tableData).length) {
                for (const k in tableData) {
                    if (tableData.hasOwnProperty(k)) {
                        const e = tableData[k];
                        const count = Math.ceil(e.length / 7);
                        const height = 44 * count + 2 * (count - 1);

                        const blankCount = count * 7 - e.length;
                        const blankDoms = [];

                        for (let i = 0; i < blankCount; i++) {
                            const ele = (
                                <div
                                    key={i}
                                    className={styles.blankTd}
                                    style={{ marginRight: (e.length + i + 1) % 7 === 0 ? 0 : 2 }}
                                />
                            );

                            blankDoms.push(ele);
                        }

                        row.push(
                            <div key={k} className={styles.row}>
                                <div className={styles.label} style={{ height, lineHeight: `${height}px` }}>
                                    {columns[k]}
                                </div>
                                <div className={styles.cow_right}>
                                    {td(e)}
                                    {blankDoms}
                                </div>
                            </div>,
                        );
                    }
                }
            } else {
                return <div className={styles.noData}>无数据</div>;
            }

            return row;
        };

        return (
            <div className={styles.content}>
                <div className={styles.col_left}>
                    <Calender onChange={this.handleChangeMonth} />
                </div>
                <div className={styles.col_right}>
                    <div className={styles.tableHead}>
                        <div className={styles.curDayStatus}>当日状态</div>
                        <div className={styles.date}>
                            <span style={{ marginRight: 24 }}>{date}</span>星期{day}
                        </div>
                    </div>
                    <div>{table()}</div>
                </div>
            </div>
        );
    }
}

export default DataTable;
